import { render, staticRenderFns } from "./CBannerComp.vue?vue&type=template&id=4831c120&"
import script from "./CBannerComp.vue?vue&type=script&lang=js&"
export * from "./CBannerComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports